export default __webpack_public_path__ + "images/resetPassword.942a77849db41d3c2e7b37e3361f045a.svg";